import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Ad = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [showCloseBtn, setShowCloseBtn] = useState(false);
  const [timer, setTimer] = useState(12); // countdown from 10 seconds

  useEffect(() => {
    const showCloseTimer = setTimeout(() => {
      setShowCloseBtn(true);
    }, 6000);

    const countdownInterval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    const autoCloseTimer = setTimeout(() => {
      setShowPopup(false);
    }, 6000);

    return () => {
      clearTimeout(showCloseTimer);
      clearTimeout(autoCloseTimer);
      clearInterval(countdownInterval);
    };
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <Overlay onClick={closePopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            {showCloseBtn && (
              <CloseButton onClick={closePopup}>×</CloseButton>
            )}
            <img src="./images/PLACE-YOUR-ADD-HERE.png" alt="Ad Popup" />
          </PopupContainer>
        </Overlay>
      )}
    </>
  );
};

export default Ad
const Overlay = styled.div`
    position: absolute;
    top:30px;
`;

const PopupContainer = styled.div`
  position: relative;
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  width: 80%;
  max-height: 90vh;
  overflow: hidden;
  text-align: center;
  margin: auto;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  background: #ef4766;
  color: white;
  border: none;
  font-size: 18px;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #c43d58;
  }
`;

const TimerText = styled.div`
  top: 6px;
  right: 35px;
  font-size: 14px;
  color: #fffff;
  font-weight:bold;
  position: absolute;
`;
